export default __webpack_public_path__ + "static/media/logo.8d05f027.png";